import React from "react";
import "../index.css";
import web from "../Images/r7.jpg";
import web1 from "../Images/c5.jpg";
import web2 from "../Images/pre.jpg";

import  web3 from '../Images/i22.jpg';

import { NavLink } from "react-router-dom";
import Common from "./Common";
const About = () => {
  return (
    <div className="container">
      <Common
        name="Stay aware of the latest "
        name1="information by regularly updates"
        imgsrc={web}
        visit="/Notifications"
        btnname="Check Updates"
      />
      <section id="header" className="d-flex align-items-center">
        <div className="container-fluid nav_bg">
          <div className="row">
            <div className="col-10 mx-auto">
              <div className="row">
                <div className="col-lg-4 pt-3 pt-lg-5 order-1 order-lg-2 d-flex justify-content-center flex-column">
                  <p>
                    <strong className="text-muted text-center">
                      Coronavirus disease 2019 (COVID-19) is an infectious
                      disease caused by severe acute respiratory syndrome
                      coronavirus 2 (SARS-CoV-2).[9] It was first identified in
                      December 2019 in Wuhan, Hubei, China, and has resulted in
                      an ongoing pandemic. On 5 October, the WHO said that one
                      in ten people around the world (around 800 million) may
                      have been infected with COVID–19.[10] As of 7 October
                      2020, 35.9 million cases have been reported across 188
                      countries and territories with more than 1.05 million
                      deaths; more than 25 million people have recovered.[8]
                    </strong>{" "}
                  </p>
                  {/* <h3 className="my-3">
              {props.name1}
              </h3> */}
                  <div className="mt-3">
                    {/* <NavLink to={props.visit} className="btn btn-md" id="b">{props.btnname}</NavLink> */}
                  </div>
                </div>
                <div class="col-lg-8 order-2 order-lg-1 header-img">
                  <img
                    src={web1}
                    className="img-fluid animated"
                    alt="home-img"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="row">
        <div className="col-10 mx-auto">
          <div className="row">
            <div className="col-lg-4 pt-3 pt-lg-5 order-2 order-lg-1 d-flex justify-content-center flex-column">
              <h2>
                <strong className="text-muted text-center">Symptions</strong>{" "}
              </h2>
              <br />
              <p>
                Seek immediate medical attention if you have serious symptoms.
                Always call before visiting your doctor or health facility.
                People with mild symptoms who are otherwise healthy should
                manage their symptoms at home.
              </p>
              {/* <h3 className="my-3">
              {props.name1}
              </h3> */}
              <div className="mt-3">
                {/* <NavLink to={props.visit} className="btn btn-md" id="b">{props.btnname}</NavLink> */}
              </div>
            </div>
            <div class="col-lg-8 order-1 order-lg-2 header-img">
              <img
                src="https://i.pinimg.com/564x/64/40/25/644025a5fa49a388b637bd5e2fb4311c.jpg"
                className="img-fluid animated"
                alt="home-img"
              />
            </div>
          </div>
        </div>
      </div>
 
          <div className="row">
         
            <div class="col-lg-6 order-2 order-lg-1 header-img">
              <img src={web3} className="img-fluid animated" alt="home-img"/>
            </div>
            <div className="col-lg-6 pt-3 pt-lg-5 order-1 order-lg-2 d-flex justify-content-center flex-column text-center">
              
              <h3><strong className="text-center">Be Aware! Virus is everywhere!!</strong> </h3>
              <div className="mt-3">
              </div>
            </div>
            </div>
  
      <div className="row">
        <div className="col-10 mx-auto">
          <div className="row">
          <div class="col-lg-4 order-1 order-lg-2 header-img mx-auto">
              <img src={web2} className="img-fluid animated" alt="home-img" />
            </div>
            <div className="col-lg-8 pt-3 pt-lg-5 order-2 order-lg-1 d-flex justify-content-center flex-column">
              <h2>
                <strong className="text-muted text-center">Prevention</strong>{" "}
              </h2>
              <p>
              Regularly and thoroughly clean your hands with an alcohol-based hand rub or wash them with soap and water. This eliminates germs including viruses that may be on your hands.
Avoid touching your eyes, nose and mouth. Hands touch many surfaces and can pick up viruses. Once contaminated, hands can transfer the virus to your eyes, nose or mouth. From there, the virus can enter your body and infect you.
Cover your mouth and nose with your bent elbow or tissue when you cough or sneeze. Then dispose of the used tissue immediately into a closed bin and wash your hands. By following good ‘respiratory hygiene’, you protect the people around you from viruses, which cause colds, flu and COVID-19.
Clean and disinfect surfaces frequently especially those which are regularly touched, such as door handles, faucets and phone screens.
              </p>
              {/* <h3 className="my-3">
              {props.name1}
              </h3> */}
              <div className="mt-3">
                {/* <NavLink to={props.visit} className="btn btn-md" id="b">{props.btnname}</NavLink> */}
              </div>
            </div>
          
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
    </div>
  );
};

export default About;
